// extracted by mini-css-extract-plugin
export default {"container":"Links_container__hmKWe","itemContainer":"Links_itemContainer__iSYQY","item":"Links_item__jafap","title":"Links_title__9Nj40","mmcApi":"Links_mmcApi__M8cWT"};